import sharedStyles from '@/components/SelfOnboarding/Shared/OnboardingFormShared.module.css'
import {TEAM_STEP_ONE} from '../../util/constants'
import {useSelector} from 'react-redux'
import type {RootState} from '@/store'

import type React from 'react'
import CustomInput from '@/components/common/CustomInputWrapper'

const TeamStepOne: React.FC<{
  values: any
  errors: any
  onChange: (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => void
  onBlur: (e: React.FocusEvent<HTMLInputElement | HTMLTextAreaElement>) => void
}> = ({values, errors, onChange, onBlur}) => {
  const isDark = useSelector((state: RootState) => state.theme.mode === 'dark')
  return (
    <div className={sharedStyles.selfOnboardingWrapper}>
      <form className="flex w-full flex-col items-start gap-4">
        <div className="flex w-[282px] flex-col items-start">
          <CustomInput
            inputSize="medium"
            name="teamName"
            label={TEAM_STEP_ONE.teamName}
            value={values.teamName}
            placeholder={TEAM_STEP_ONE.teamNamePlaceholder}
            error={errors.teamName}
            onChange={onChange}
            onBlur={onBlur}
            helperText={TEAM_STEP_ONE.teamNameHelper}
          />
        </div>
        <div className="flex w-[282px] flex-col items-start">
          <CustomInput
            inputSize="medium"
            name="ownerName"
            label={TEAM_STEP_ONE.ownerName}
            value={values.ownerName}
            placeholder={TEAM_STEP_ONE.ownerNamePlaceholder}
            error={errors.ownerName}
            onChange={onChange}
            onBlur={onBlur}
            helperText={TEAM_STEP_ONE.ownerNameHelper}
          />
        </div>
        <div className="flex w-[282px] flex-col items-start">
          <CustomInput
            inputSize="medium"
            name="email"
            label={TEAM_STEP_ONE.ownerEmail}
            value={values.email}
            placeholder={TEAM_STEP_ONE.ownerEmailPlaceholder}
            error={errors.email}
            onChange={onChange}
            onBlur={onBlur}
            helperText={TEAM_STEP_ONE.ownerEmailHelper}
          />
        </div>
      </form>
    </div>
  )
}

export default TeamStepOne
